import React, { useState } from "react";
import {
  Tooltip,
  IconButton,
  Popper,
  Paper,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import {
  SMSOutgoingIcon,
  CustomerIcon,
  ElevationIcon,
} from "../../../../components/mui/index.js";
import { useBulkInvoiceActions } from "../actions/bulk-actions.component.js";

export function OverageBulkPopper({ data, snackbarRef, didActionsOccur }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const bulk = useBulkInvoiceActions({
    snackbarRef,
  });

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  // Bulk SMS Overage
  const handleBulkSmsOverageClick = (e) => {
    e.stopPropagation();
    bulk.handleBulkSmsOverageUpdate(data, (attempted) => {
      if (typeof didActionsOccur === "function") didActionsOccur(attempted);
    });
    handleClose();
  };

  // Bulk Customer Count Overage
  const handleBulkCustomerCountOverageClick = (e) => {
    e.stopPropagation();

    bulk.handleBulkCustomerCountOverageUpdate(data, (attempted) => {
      if (typeof didActionsOccur === "function") didActionsOccur(attempted);
    });
    handleClose();
  };

  return (
    <>
      <Tooltip title={!open ? <Typography>Overage Actions</Typography> : null}>
        <IconButton onClick={handleClick}>
          <ElevationIcon />
        </IconButton>
      </Tooltip>
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="top-start"
        style={{ zIndex: 1300 }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper sx={{ p: 2, minWidth: 260 }}>
            <Stack
              spacing={2}
              direction="row"
              alignItems="center"
              justifyContent="center"
              sx={{ width: "100%" }}
            >
              {/* Bulk SMS Overage Action */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  flex: 1,
                  cursor: "pointer",
                  borderRadius: 2,
                  transition: "background 0.2s",
                  "&:hover": {
                    backgroundColor: "#f0f7ff",
                  },
                  py: 1,
                }}
                onClick={handleBulkSmsOverageClick}
                tabIndex={0}
                role="button"
                aria-label="Bulk Add SMS Overage"
              >
                <Tooltip
                  title={
                    data?.length ? (
                      <Typography>
                        Add SMS Overage to all selected invoices
                      </Typography>
                    ) : (
                      <Typography>
                        Please link all selected invoices to an account before
                        updating SMS overage
                      </Typography>
                    )
                  }
                  placement="top"
                  arrow
                >
                  <span>
                    <SMSOutgoingIcon
                      color="primary"
                      fontSize="large"
                      sx={{ mb: 0.5 }}
                    />
                  </span>
                </Tooltip>
                <Typography
                  variant="caption"
                  sx={{ mt: 0.5, fontWeight: 500, textAlign: "center" }}
                >
                  SMS Overage
                </Typography>
              </Box>

              {/* Bulk Customer Count Overage Action */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  flex: 1,
                  cursor: "pointer",
                  borderRadius: 2,
                  transition: "background 0.2s",
                  "&:hover": {
                    backgroundColor: "#f0f7ff",
                  },
                  py: 1,
                }}
                onClick={handleBulkCustomerCountOverageClick}
                tabIndex={0}
                role="button"
                aria-label="Bulk Add Customer Count Overage"
              >
                <Tooltip
                  title={
                    data?.length ? (
                      <Typography>
                        Add Customer Count Overage to all selected invoices
                      </Typography>
                    ) : (
                      <Typography>
                        Please link all selected invoices to an account before
                        updating Customer Count overage
                      </Typography>
                    )
                  }
                  placement="top"
                  arrow
                >
                  <span>
                    <CustomerIcon
                      color="primary"
                      fontSize="large"
                      sx={{ mb: 0.5 }}
                    />
                  </span>
                </Tooltip>
                <Typography
                  variant="caption"
                  sx={{ mt: 0.5, fontWeight: 500, textAlign: "center" }}
                >
                  Customer Count Overage
                </Typography>
              </Box>
            </Stack>
          </Paper>
        </ClickAwayListener>
      </Popper>
      {bulk.modals}
    </>
  );
}
